module.exports = __webpack_public_path__ + "static/img/xcx.4a9de24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xcx.png
// module id = Phit
// module chunks = 15